import { IOrderClause } from '~src/spacesPlatform/serverApi/types/IOrderClause';

import { AppState } from '../../bootstrap/redux/state/AppState';

export function selectContentSort(state: AppState): ReadonlyArray<IOrderClause> {
  return state.order.order;
}

export function selectContentSortIgnoreNextUrlChange(state: AppState): boolean {
  return state.order.ignoreNextUrlChange;
}
